module.exports = __webpack_public_path__ + "img/IM.4a90ba0e.png";